import { CreateButton } from "react-admin";

const MyCreateButton = (props) => (
  <CreateButton
    {...props}
    component="button" // no longer a <Link>
    to={undefined} // remove the `to` prop if necessary
  />
);

export default MyCreateButton;
